import React from 'react';
import { humanizeString } from 'app/helpers/humanizeString';
import { DsTag } from '@tokenyico/design-system/dist/reactJS';

const CEXStatus = ({ status, ...rest }) => {
  const versions = {
    pending: 'warning',
    approved: 'success',
    rejected: 'error',
    failled: 'error',
    in_progress: 'warning',
    revoked: 'error',
  };

  const icons = {
    pending: 'pending',
    approved: 'verified',
    rejected: 'cross-circle',
    failled: 'cross-circle',
    in_progress: 'loader-circle',
    revoked: 'undo',
  };

  if (!status) return null;
  return (
    <DsTag
      label={humanizeString(status) || '-'}
      version={versions[status.toLowerCase()] || 'default'}
      icon={icons[status.toLowerCase()]}
      iconSize="14px"
      size="xs"
      {...rest}
    />
  );
};

export default CEXStatus;
